import { ReactNode } from 'react';

import styles from './FilterSection.module.css';

export interface FilterSectionWrapperProps {
  /** Usually two `FilterSectionGroup`s, pushed to opposite ends of the row. */
  children: ReactNode;
  className?: string;
}

/**
 * Horizontal filter bar that wraps on narrow screens.
 *
 * @example
 * <FilterSectionWrapper>
 *   <FilterSectionGroup>
 *     <FilterDropdown label="Owner" ... />
 *   </FilterSectionGroup>
 *   <FilterSectionGroup>
 *     <CheckboxFilter label="Starred" ... />
 *     <SearchFilter onChange={setSearch} />
 *   </FilterSectionGroup>
 * </FilterSectionWrapper>
 */
export const FilterSectionWrapper = ({
  children,
  className,
}: FilterSectionWrapperProps) => (
  <div className={[styles.wrapper, className].filter(Boolean).join(' ')}>
    {children}
  </div>
);

export interface FilterSectionGroupProps {
  children: ReactNode;
  className?: string;
}

/** Row of filter controls inside a `FilterSectionWrapper`. */
export const FilterSectionGroup = ({
  children,
  className,
}: FilterSectionGroupProps) => (
  <div className={[styles.group, className].filter(Boolean).join(' ')}>
    {children}
  </div>
);
